export const formatDisplayName = (account) => {
	const { display_name } = account?.metadata || {};
	const { product } = account;
	return display_name && display_name.trim().length > 0 ? display_name : product.name;
};

export const getDisplayOrder = ({ account, index }) => {
	const { display_order } = account.metadata;
	return display_order && display_order > 0 ? display_order : index;
};

export const getSortCodeAndAccountNumber = (number = '') => {
	const splits = number.split('-');
	return {
		sortCode: splits[0],
		accountNumber: splits[1],
	};
};

export const getBalances = (account) => {
	let balances = [];
	if (account.actions_available && !account.actions_available['/account/read/limited']) {
		const actualBalances = account.balances || [];
		balances = actualBalances.map((balance) => {
			const { value: amount, currency } = balance.amount;
			return {
				type: balance.type,
				amount,
				currency,
			};
		});
	}
	return balances;
};
